import { getWorkspaceId } from "./getCredentials";
import { requestFromToggl } from "./requestFromToggl";

export function getClients(successCb, failCb) {
  const url = `https://api.track.toggl.com/api/v9/workspaces/${getWorkspaceId()}/clients`;
  const method = "GET";

  requestFromToggl(url, method, {}, successCb, failCb);
}
